<template>
  <div class="user-detail">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>ユーザー</span>
          </li>
        </ul>
      </div>
      <!-- <h1 class="title">ユーザ管理</h1> -->
    </div>
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div class="section">
        <div class="container">
          <!-- <h2 class="title">ユーザ情報</h2> -->
          <div
            class="error-message mdi mdi-alert-circle-outline"
            v-if="errorMessage"
          >
            {{ errorMessage }}
          </div>
          <dl class="columns">
            <dt>メールアドレス</dt>
            <dd v-if="viewMode === 'a'">
              <ValidationProvider
                rules="required|customEmail|max:128"
                immediate
                v-slot="ProviderProps"
              >
                <input type="text" v-model="curUser.email" />
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
            <dd v-else-if="viewMode === 'e'">
              {{ curUser.email }}
            </dd>
          </dl>
          <dl class="columns">
            <dt>ユーザー名</dt>
            <dd>
              <ValidationProvider
                rules="required|max:50"
                immediate
                v-slot="ProviderProps"
              >
                <input type="text" v-model="curUser.displayName" />
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>色</dt>
            <dd>
              <div
                v-for="(row, index) in colors"
                :key="index"
                class="color-radio-button"
                :style="{
                  background: row === curUser.color ? '#ddd' : '',
                }"
              >
                <label>
                  <input
                    type="radio"
                    name="user_color"
                    :value="row"
                    v-model="curUser.color"
                  />
                  <div
                    :style="{
                      background: row,
                    }"
                  ></div>
                </label>
              </div>
            </dd>
          </dl>
          <dl v-if="viewMode === 'a'" class="columns">
            <dt>仮パスワード</dt>
            <dd>
              <ValidationProvider
                rules="required|complexPassword"
                immediate
                v-slot="ProviderProps"
              >
                <input type="password" v-model="curUser.temporaryPassword" />
                <p
                  class="legend"
                  :class="{ 'validation-error': ProviderProps.invalid }"
                >
                  8文字以上、アルファベット大文字・小文字・数字をそれぞれ1つ以上含む。
                </p>
              </ValidationProvider>
            </dd>
          </dl>
        </div>
      </div>
      <div id="button-area">
        <div class="left-box" />
        <div class="center-box">
          <span
            v-if="viewMode === 'e'"
            class="btn btn-submit"
            :class="{
              active: isRootUser || isOwnUser,
              disable: ObserverProps.invalid || !(isRootUser || isOwnUser),
            }"
            @click="updateUser"
            >保存</span
          >
          <span
            v-else
            class="btn btn-submit"
            :class="{
              active: true,
              disable: ObserverProps.invalid,
            }"
            @click="addUser"
            >登録</span
          >
          <span class="btn btn-cancel" @click="backToList">キャンセル</span>
        </div>
        <div class="right-box">
          <span
            v-if="viewMode === 'e'"
            class="text"
            :class="{ active: isRootUser && !isOwnUser, disable: !isRootUser || isOwnUser }"
            @click="removeUser(curUser.username)"
            >削除</span
          >
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { Auth, API } from "aws-amplify";
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";
import Dialog from "@/mixins/dialog";

export default {
  components: {},
  mixins: [Loader, Dialog],

  props: {
    viewMode: {
      type: String,
      default: "a",
    },
    viewData: {
      type: Object,
    },
    prmIsRootUser: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      curUser: {
        username: null,
        displayName: null,
        email: null,
        temporaryPassword: null,
        color: null,
      },
      errorMessage: null,
      colors: [
        "#E57373",
        "#F06292",
        "#BA68C8",
        "#9575CD",
        "#7986CB",
        "#64B5F6",
        "#4DD0E1",
        "#FFD54F",
        "#FFB74D",
        "#FF8A65",
        "#A1887F",
        "#90A4AE",
      ],
      isRootUser: false,
      isOwnUser: false,
    };
  },
  async mounted() {
    this.isRootUser = this.prmIsRootUser;
    if (this.viewMode === "e") {
      this.curUser.username = this.viewData.username;
      this.curUser.displayName = this.viewData.displayName;
      this.curUser.email = this.viewData.email;
      this.curUser.color = this.viewData.color;
      if (!this.curUser.color) {
        this.curUser.color = this.colors[0];
      }

      const uid = await this.showUserId();
      this.isOwnUser = (uid && this.viewData.user_id === uid);
    } else {
      this.curUser.color = this.colors[0];
    }
  },

  methods: {
    ...mapActions(["showUsername", "showProfile", "showUserId"]),

    async addUser() {
      this.loading(async () => {
        // TODO validation
        let apiName = "AdminQueries";
        let path = "/adminCreateUser";
        let myInit = {
          body: {
            username: this.curUser.email,
            displayName: this.curUser.displayName,
            email: this.curUser.email,
            temporaryPassword: this.curUser.temporaryPassword,
            color: this.curUser.color,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `${(await Auth.currentSession())
              .getAccessToken()
              .getJwtToken()}`,
          },
        };
        try {
          await API.post(apiName, path, myInit);
          this.errorMessage = null;

          // 一覧をリロード
          this.$router.push({ name: "users" });
        } catch (err) {
          if (err.response && err.response.data && err.response.data.message) {
            this.errorMessage = err.response.data.message;
          } else if (err.message) {
            this.errorMessage = err.message;
          }
        }
      });
    },

    async updateUser() {
      this.loading(async () => {
        // TODO validation
        let apiName = "AdminQueries";
        let path = "/adminUpdateUser";
        let myInit = {
          body: {
            username: this.curUser.username,
            displayName: this.curUser.displayName,
            email: this.curUser.email,
            color: this.curUser.color,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `${(await Auth.currentSession())
              .getAccessToken()
              .getJwtToken()}`,
          },
        };
        try {
          await API.post(apiName, path, myInit);
          this.errorMessage = null;
          // 更新対象がログインユーザの場合はプロフィールを取得し直す
          if (this.curUser.username === (await this.showUsername())) {
            await this.showProfile();
          }

          // 一覧をリロード
          this.$router.push({ name: "users" });
        } catch (err) {
          if (err.response && err.response.data && err.response.data.message) {
            this.errorMessage = err.response.data.message;
          } else if (err.message) {
            this.errorMessage = err.message;
          }
        }
      });
    },

    async removeUser(username) {
      this.showConfirm(`${username} を削除しますか？`, async () => {
        this.loading(async () => {
          let apiName = "AdminQueries";
          let path = "/adminDeleteUser";
          let myInit = {
            body: {
              username: username,
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: `${(await Auth.currentSession())
                .getAccessToken()
                .getJwtToken()}`,
            },
          };

          try {
            await API.post(apiName, path, myInit);
            // 一覧をリロード
            this.$router.push({ name: "users" });
          } catch (err) {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.errorMessage = err.response.data.message;
            } else if (err.message) {
              this.errorMessage = err.message;
            }
          }
        });
      });
    },

    backToList() {
      this.$router.push({ name: "users" });
    },
  },
};
</script>

<style lang="scss">
.user-detail {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 50%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;

      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 170px 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      .color-radio-button {
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 10px;
        margin: 2px;
        float: left;
      }
      .color-radio-button:hover {
        background: #eee;
      }
      .color-radio-button div {
        height: 36px;
        width: 36px;
        border-radius: 50%;
      }
      .color-radio-button label {
        cursor: pointer;
      }

      /* フォーム */

      input[type="text"],
      input[type="password"],
      input[type="date"] {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 16px;
        font-size: 16px;
        outline: none;
      }

      input[type="text"]:focus,
      input[type="password"]:focus,
      input[type="date"]:focus {
        background: var(--purple-tertiary);
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }

      textarea {
        font-size: 16px;
        width: 100%;
        min-height: 200px;
        white-space: pre-wrap;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: solid 1px var(--purple);
        padding: 10px;
        border-radius: 10px 10px 0 10px;
      }

      textarea:focus {
        background: var(--purple-tertiary);
      }

      input[type="radio"] {
        display: none;
      }
      input[type="radio"] + label {
        padding: 0 20px 0 0;
      }
      input[type="radio"]:disabled + label {
        color: #aaa;
      }

      input[type="radio"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="radio"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center left;
        background-size: 24px 24px;
        display: inline-block;
      }
      input[type="radio"]:disabled + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
          center left;
        background-size: 24px 24px;
        display: inline-block;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }
    }
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .right-box {
      right: 0;
      bottom: 0;
      width: 25%;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 50%);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 25%;
      .mobile & {
        width: unset;
      }
    }
    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
      width: 130px;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_account-box.svg") no-repeat center
      center;
  }
}
</style>
